import React from "react";

const gstData = [
  { id: "01.", state: "Andaman and Nicobar Islands", url: "https://www.andaman.gov.in" },
  { id: "02.", state: "Andhra Pradesh", url: "https://apct.gov.in" },
  { id: "03.", state: "Arunachal Pradesh", url: "https://tax.arunachal.gov.in" },
  { id: "04.", state: "Assam", url: "https://tax.assam.gov.in" },
  { id: "05.", state: "Bihar", url: "https://state.bihar.gov.in/commercialtax" },
  { id: "06.", state: "Chandigarh", url: "https://etdut.chd.gov.in" },
  { id: "07.", state: "Chhattisgarh", url: "https://comtax.cg.nic.in" },
  { id: "08.", state: "Dadra and Nagar Haveli", url: "https://ddd.gov.in" },
  { id: "09.", state: "Daman and Diu", url: "https://ddd.gov.in" },
  { id: "10.", state: "Delhi", url: "https://dvat.gov.in" },
  { id: "11.", state: "Goa", url: "https://goacomtax.gov.in" },
  { id: "12.", state: "Gujarat", url: "https://commercialtax.gujarat.gov.in" },
  { id: "13.", state: "Haryana", url: "https://haryanatax.gov.in" },
  { id: "14.", state: "Himachal Pradesh", url: "https://hptax.gov.in" },
  { id: "15.", state: "Jammu and Kashmir", url: "https://jkcomtax.gov.in" },
  { id: "16.", state: "Jharkhand", url: "https://comtax.jharkhand.gov.in" },
  { id: "17.", state: "Karnataka", url: "https://ctax.kar.nic.in" },
  { id: "18.", state: "Kerala", url: "https://keralataxes.gov.in" },
  { id: "19.", state: "Lakshadweep", url: "https://lakshadweep.gov.in" },
  { id: "20.", state: "Madhya Pradesh", url: "https://commercialtax.mp.gov.in" },
  { id: "21.", state: "Maharashtra", url: "https://mahagst.gov.in" },
  { id: "22.", state: "Manipur", url: "https://manipurtaxes.gov.in" },
  { id: "23.", state: "Meghalaya", url: "https://megtax.gov.in" },
  { id: "24.", state: "Mizoram", url: "https://tax.mizoram.gov.in" },
  { id: "25.", state: "Nagaland", url: "https://nagalandtax.nic.in" },
  { id: "26.", state: "Odisha", url: "https://odishatax.gov.in" },
  { id: "27.", state: "Puducherry", url: "https://gst.py.gov.in" },
  { id: "28.", state: "Punjab", url: "https://tax.punjab.gov.in" },
  { id: "29.", state: "Rajasthan", url: "https://rajtax.gov.in" },
  { id: "30.", state: "Sikkim", url: "https://sikkimtax.gov.in" },
  { id: "31.", state: "Tamil Nadu", url: "https://ctd.tn.gov.in" },
  { id: "32.", state: "Tripura", url: "https://tripurataxes.nic.in" },
  { id: "33.", state: "Telangana", url: "https://tgct.gov.in" },
  { id: "34.", state: "Uttarakhand", url: "https://comtax.uk.gov.in" },
  { id: "35.", state: "Uttar Pradesh", url: "https://comtax.up.gov.in" },
  { id: "36.", state: "West Bengal", url: "https://wbcomtax.gov.in" },
];

export default function GstVat() {
  return (
    <div
      className="gstvat-wrapper"
      style={{
        padding: "100px 20px 40px",
        fontFamily: "Arial, sans-serif"
      }}
    >
      <div className="max-w-[1100px] mx-auto" style={{ maxWidth: "1100px", margin: "0 auto" }}>

        {/* Header */}
        <div
          className=" gst-header px-4 py-4 sm:px-5 sm:py-5"
          style={{
            background: "#f0f7ff",
            border: "1px solid #d1d5db",
            borderRadius: "8px",
            padding: "20px",
            textAlign: "center",
            marginBottom: "25px",
            boxShadow: "0 2px 5px rgba(0,0,0,0.05)"
          }}
        >
          <h2 style={{ color: "#1a3c6e", margin: 0, fontSize: "22px", fontWeight: "700", textTransform: "uppercase" }}>
            Goods and Service Tax Website of Indian States
          </h2>
        </div>

        {/* TABLE CONTAINER (MOBILE FIX) */}
        <div
          style={{ border: "1px solid #e5e7eb", borderRadius: "8px", overflowX: "auto" }}
        >
          <table
            className="min-w-[600px]"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "#fff",
              textAlign: "left"
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f3f4f6" }}>
                <th style={styles.th}>S. No.</th>
                <th style={styles.th}>State</th>
                <th style={{ ...styles.th, borderRight: "none" }}>Website</th>
              </tr>
            </thead>

            <tbody>
              {gstData.map((item, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #e5e7eb" }}>

                  <td className="whitespace-nowrap" style={{ ...styles.td, width: "70px" }}>
                    {item.id}
                  </td>

                  <td className="whitespace-nowrap sm:whitespace-normal" style={{ ...styles.td, width: "300px" }}>
                    {item.state}
                  </td>

                  <td className="whitespace-nowrap" style={{ ...styles.td, borderRight: "none" }}>
                    <a
                      href={item.url.startsWith('http') ? item.url : `https://${item.url}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="break-all"
                      style={{ color: "#1d4ed8", textDecoration: "none" }}
                    >
                      {item.url}
                    </a>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}

const styles = {
  th: {
    padding: "15px",
    fontSize: "15px",
    fontWeight: "700",
    color: "#374151",
    borderBottom: "1px solid #e5e7eb",
    borderRight: "1px solid #e5e7eb",
    backgroundColor: "#f9fafb"
  },
  td: {
    padding: "12px 15px",
    fontSize: "14px",
    color: "#4b5563",
    borderRight: "1px solid #e5e7eb"
  }
};